import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api';
import { SavedQueryGroup, TreeNode } from '../interfaces/queryBuilderInterfaces';


interface FolderPayload {
    name?: string;
    id?: number; // Added optional 'id' property
}

export const fetchFolders = createAsyncThunk('folder/list', async () => {
    const response = await axiosInstance.get(`/rest/folder/list`);
    return response.data;
});

export const fetchFolderReports = createAsyncThunk('folder/reports', async () => {
    const response = await axiosInstance.get(`/rest/folder/reports`);
    return response.data;
});

export const addFolder = createAsyncThunk('folder/add', async (payload: FolderPayload) => {
    const response = await axiosInstance.post(`/rest/folder/add/${payload.name}`);
    return response.data;
});

export const deleteFolder = createAsyncThunk('folder/delete', async (payload: FolderPayload) => {
    const response = await axiosInstance.delete(`/rest/folder/delete/${payload.id}`);
    return response.data;
});

export const renameFolder = createAsyncThunk('folder/rename', async (payload: FolderPayload) => {
    const response = await axiosInstance.post(`/rest/folder/rename/${payload.id}/${payload.name}`, { id: payload.id, name: payload.name });
    return response.data;
});

export const saveFolder = createAsyncThunk('folder/save', async ({ folderId, reportId }: { folderId: string; reportId: string }) => {
    const response = await axiosInstance.post(`/rest/folder/report/${folderId}/${reportId}`);
    return response.data;
});

export const deleteReportFromFolder = createAsyncThunk('folder/report/delete', async ({ folderId, reportId }: { folderId: number; reportId: number }) => {
    const response = await axiosInstance.delete(`/rest/folder/report/${folderId}/${reportId}`);
    return response.data;
});

export const copyReportToFolder = createAsyncThunk('folder/report/', async ({ folderId, reportId }: { folderId: string; reportId: number }) => {
    const response = await axiosInstance.post(`/rest/folder/report/${folderId}/${reportId}`);
    return response.data;
});


const initialState = {
    folders: [{
        id: -1, name: 'My Queries', children: [] as any[]},
        {id: -2, name: 'Shared With Me', children: null},
        //{id: -4, name: 'Legacy TipNet Queries', children: null}
    ],
    selectedFolder: {id: -1, name: 'My Queries'}, // Added selectedFolder property
    folderResports: [],
    contextMenuVisible: false,
};

const folderSlice = createSlice({
    name: 'folder',
    initialState,
    reducers: {
        selectedFolder: (state, action) => {
            state.selectedFolder = action.payload;
        },
        updateContextMenuVisibility: (state, action) => {
            state.contextMenuVisible = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFolders.fulfilled, (state, action) => {
                if (state.folders[0].children) {
                    state.folders[0].children = [{id: -3, name: 'Default'},...action.payload];
                }
 
            })
            .addCase(fetchFolderReports.fulfilled, (state, action) => {
                state.folderResports = action.payload;
            });
            
    },
});
export const { selectedFolder, updateContextMenuVisibility } = folderSlice.actions;
export default folderSlice.reducer;
